import ErrorAnalysisChart from './error-analysis-chart';

export default ErrorAnalysisChart;
